import type { IFieldOptions } from '@axo/form/feature/form-input/types';

export const militaryServiceCompletedFieldOptions = {
  registerOptions: {
    shouldUnregister: true,
    required: 'MilitaryServiceCompleted.error.required',
  },
  warningValidation: {
    message: (value) => {
      if (value === 'No') {
        return 'MilitaryServiceCompleted.error.required';
      }
    },
  },
} satisfies IFieldOptions;
